import { database, storage } from '@/services/firebase';
export default {
  data () {
    return {
      refExpense: database.ref('expense'),
      expenses: []
    }
  },
  methods: {
    getExpenses (itemId) {
      return new Promise((resolve, reject) => {
        var app = this;
        ((itemId) ? this.refExpense.equalTo(Number(itemId)) : this.refExpense)
        .once('value', function (snapshot) {
          app.refExpense = [];
          snapshot.forEach(function (childSnapshot) {
            app.expenses.push(childSnapshot.val());
          });
          console.log('getExpenses', app.expenses);
          resolve(app.expenses);
        })
        .catch((error) => {
          reject(error)
        })
      });
    },
    deleteExpense (itemId) {
      return new Promise((resolve, reject) => {
        console.log('deleteExpense: ', itemId);
        var dbref = database.ref('expense');
        dbref.orderByChild('id').equalTo(itemId).once('value', snapshot => {
          // let updates = {};
          snapshot.forEach((child) => {
            dbref.child(child.key).remove();
            storage.ref('expense/' + child.key).delete();
            resolve(true)
          });
        })
        .catch((error) => {
          reject(error)
        })
      });
    }
  }
}
